<template>
  <div
    class="header-actions__element header-actions__element_envelop"
    :data-ref="$options.consts.REFS.NEWSLETTER_HEADER_BUTTON_WRAPPER"
  >
    <a-visibility show :on="[$breakpoint.tablet]">
      <a-icon
        :icon="$options.consts.ICON.ENVELOPE_2"
        :width="38"
        :height="29"
        fill="#fff"
        is-button
        class="header-actions__action-item"
        id="header-newsletter-button-tablet"
        aria-label="Newsletter"
        @click="onOpenNewsletter"
      />
    </a-visibility>
    <a-visibility show :on="[$breakpoint.mobile]">
      <a-icon
        :icon="$options.consts.ICON.ENVELOPE_2"
        :width="25"
        :height="19"
        fill="#fff"
        is-button
        id="header-newsletter-button-mobile"
        aria-label="Newsletter"
        class="header-actions__action-item"
        @click="onOpenNewsletter"
      />
    </a-visibility>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon'
import { REFS } from 'enums/external-refs'

export default {
  name: 'NewsletterIcon',
  components: { AIcon },
  consts: { ICON, REFS },
  methods: {
    onOpenNewsletter() {
      this.$emit('open-newsletter')
    }
  }
}
</script>

<style scoped lang="scss"></style>
